import { render, staticRenderFns } from "./MineSvg.vue?vue&type=template&id=cbf11d62&"
var script = {}
import style0 from "./MineSvg.vue?vue&type=style&index=0&id=cbf11d62&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports